module.exports = __webpack_public_path__ + "img/app.588bbe9d.jpg";